var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from 'react';
import { SvgCircleIcon } from './svg-circle-icon';
export var FacebookIcon = function (props) {
  return React.createElement(SvgCircleIcon, __assign({}, props, {
    glyphWidth: 27,
    glyphHeight: 53
  }), React.createElement("path", {
    d: "M17.7696 17.7669V12.5669C17.7696 10.2919 18.3112 9.10026 21.8862 9.10026H26.4362V0.433594H19.5029C10.8362 0.433594 7.36955 6.17526 7.36955 12.5669V17.7669H0.436218V26.4336H7.36955V52.4336H17.7696V26.4336H25.3529L26.4362 17.7669H17.7696Z",
    fill: "black"
  }));
};
export var FacebookIconGlyph = function (props) {
  return React.createElement(FacebookIcon, __assign({}, props, {
    variant: 'glyph'
  }));
};